module.exports = __webpack_public_path__ + "img/icon_menu.28e6f835.svg";